<template>
    <div class="container-fluid p-0">
    <nav 
        :class="[
            'navbar', 
            'navbar-expand',
            'navbar-fixed-top',
            'navbar-dark',
            'bg-dark',
            'page-margin',
            'p-0',
            'rounded-bottom'
        ]"
    >
        <a class="navbar-brand p-0 m-0">
            <router-link to="/painel" class="navbar-brand-link">
                <img 
                    id="nav-bar-logo"
                    src="@/assets/card.png" 
                    alt="Logo"
                    class="img-fluid"
                >
            </router-link>
        </a>
        <ul class="navbar-nav mx-auto">
            <li>
                <router-link
                    to="/painel"
                    class="nav-link font-roboto"
                    active-class="active"
                    aria-current="page"
                    :title="`Voltar ao Início`"
                >
                    Início
                </router-link>
            </li>
            <li>
                <router-link
                    to="/operacoes"
                    class="nav-link font-roboto"
                    active-class="active"
                    aria-current="page"
                    :title="`Cadastre operações financeiras`"
                >
                    Operações
                </router-link>
            </li>
            <li v-if="isOwner()" class="nav-item dropdown">
                <a 
                    class="nav-link dropdown-toggle font-roboto" 
                    href="#" 
                    id="navbarDropdown2" 
                    role="button" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                >
                    Controladoria
                </a>
                <ul class="dropdown-menu m-0 p-0" aria-labelledby="navbarDropdown2">
                    <li>
                        <router-link
                            to="/controladoria-mensal"
                            class="dropdown-item"
                            active-class="active"
                            :title="`Painel de controladoria por mês`"
                        >
                            Mensal
                        </router-link>
                    </li>
                    <li>
                        <router-link 
                            to="/controladoria-anual" 
                            class="dropdown-item"
                            :title="`Painel de controladoria por ano`"
                            active-class="active"
                        >
                            Anual
                        </router-link>
                    </li>
                </ul>
            </li>
            <li class="nav-item dropdown" v-if="isOwner()">
                <a 
                    class="nav-link dropdown-toggle font-roboto" 
                    href="#" 
                    id="navbarDropdown" 
                    role="button" 
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                >
                    Gerenciar
                </a>
                <ul class="dropdown-menu m-0 p-0" aria-labelledby="navbarDropdown">
                    <li v-if="isAdmin()">
                        <router-link 
                            to="/editar-rede" 
                            class="dropdown-item"
                            :title="`Cadastre, edite ou exclua redes`"
                            active-class="active"
                        >
                            Redes
                        </router-link>
                    </li>
                    <li>
                        <router-link 
                            to="/editar-loja" 
                            class="dropdown-item"
                            :title="`Cadastre, edite ou exclua lojas`"
                            active-class="active"
                        >
                            Lojas
                        </router-link>
                    </li>
                    <li>
                        <router-link 
                            to="/editar-operador" 
                            class="dropdown-item"
                            :title="`Cadastre, edite ou exclua operadores`"
                            active-class="active"
                        >
                            Operadores
                        </router-link>
                    </li>
                    <li v-if="isAdmin()">
                        <router-link 
                            to="/parametros" 
                            class="dropdown-item"
                            :title="`Edite os parâmetros do sistema`"
                            active-class="active"
                        >
                            Parâmetros
                        </router-link>
                    </li>
                </ul>
            </li>
        </ul>
        <form class="d-flex ms-1">
            <button
                type="button"
                class="btn btn-primary light-text" 
                @click.prevent="goToAccount"
            >
            <i class="bi bi-person-circle"></i> <span>&nbsp;</span> Conta
            </button>
            <button
                type="button"
                class="btn btn-primary light-text" 
                @click.prevent="goToFAQ"
            >
            <i class="bi bi-question-circle"></i> <span>&nbsp;</span> Ajuda
            </button>
            <button
                type="button"
                class="btn btn-primary light-text btn-logout" 
                @click.prevent="logout"
            >
            <i class="bi bi-box-arrow-right"></i> <span>&nbsp;</span> Sair
            </button>
        </form>
    </nav>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pages: []
        };
    },
    methods: {
        goToAccount() {
            this.$router.push('/conta');
        },
        goToFAQ() {
            this.$router.push('/faq');
        },
        logout() {
            this.$axios.get('/api/logout')
                .then(() => {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.dispatchEvent(new CustomEvent('isLoggedInChanged', { detail: false }));
                    this.$router.push('/login');
                })
                .catch(() => {
                    // If the server is down, the user is logged out anyway
                    
                    localStorage.clear();
                    sessionStorage.clear();
                    window.dispatchEvent(new CustomEvent('isLoggedInChanged', { detail: false }));
                    this.$router.push('/login');
                });
        },
        isAdmin() {
            return localStorage.getItem('role') === 'administrador';
        },
        isOwner() {
            return localStorage.getItem('role') === 'donorede' || localStorage.getItem('role') === 'administrador';
        }
    }
}
</script>

<style scoped>
.navbar {
    background-color: #42413f !important;
    min-width: fit-content; 
}
.navbar-brand { 
    width: 180px; /* "Conserta" centralização dos itens */
}

ul.navbar-nav {
    gap: 20px;
    font-weight: bold;
}

ul.navbar-nav li a {
    border-radius: 5px;
}
ul.navbar-nav li a:hover {
    background-color: #5a5a5a; /* Cor ligeiramente mais clara */
}

button.btn-primary {
    width: 100px;
    margin-right: 10px;
    font-weight: bold;
    background-color: #003867;
    border-color: #003867;
}
button.btn-primary:hover{
    background-color: #ffd700;
    border-color: #ffd700;
}

button.btn-logout {
    background-color: #ff0000;
    border-color: #ff0000;
}

button.btn-logout:hover {
    color: #ff0000;
    background-color: white;
    border-color: white;
}

.dropdown-item:hover {
    background-color: #003867 !important;
    color: white;
}
</style>